export const ERROR_OLAS_LIST = 'movilidad/reportepedidos/error-olas-list';
export const RECEIVE_OLAS_LIST = 'movilidad/reportepedidos/receive-reportepedidos-list';
export const  RECEIVE_OLAS_DET = 'movilidad/reportepedidos/receive-reportepedidos-det';
export const REQUEST_OLAS_LIST = 'movilidad/reportepedidos/request-reportepedidos-list';
export const RESTART_STATE = 'movilidad/reportepedidos/restart_state';
export const SET_MASK = 'movilidad/reportepedidos/set-mask';
export const SET_ORDER = 'movilidad/reportepedidos/set-order';
export const SET_SELECTED_ROW = 'movilidad/reportepedidos/set-selected-row';
export const UPDATE_FIELD_FILTER = 'movilidad/reportepedidos/update-field-filter';
export const UPDATE_TABLE_COLUMN = 'movilidad/reportepedidos/set-selected-row';